

import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from './App'
import router from'./router/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import axios from 'axios'
import clipboard from 'clipboard';
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Toast from 'vux/src/components/toast/index.vue'


Vue.component('tabbar', Tabbar)
Vue.component('tabbar-item', TabbarItem)
Vue.component('button-tab', ButtonTab)
Vue.component('button-tab-item', ButtonTabItem)
Vue.component('XButton', XButton)
Vue.component('XInput', XInput)
Vue.component('Group', Group)
Vue.component('Check-icon', CheckIcon )
Vue.component('Grid', Grid )
Vue.component('GridItem', GridItem )
Vue.component('alert', Alert )
Vue.component('toast', Toast)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)

import '../src/assets/rem.js'

Vue.prototype.clipboard = clipboard

Vue.prototype.$http = axios;


FastClick.attach(document.body)

Vue.config.productionTip = false

Vue.use(VueRouter)

new Vue({
router,            //-----router文件
el: '#app-box',
template: '<App/>',
components: { App }
})










// WEBPACK FOOTER //
// ./src/main.js